<app-visor/>
<section>
  <div class="flex flex-column">
    <div class="mb-2">
      <CustomTitle [title]="trans.documentos"
                   styleClass="font-roboto-condensed font-18 title-blue text-uppercase font-normal mb-0" />
    </div>
    <div class="pl-2 flex flex-column gap-2" *ngIf="!isLoading; else cargando">
      @if(data.length == 0){
        <div>
          {{ trans.noHayDocumentos }}
        </div>
      }
      @else {
        <div *ngFor="let documento of data" class="flex gap-2 align-items-center">
          <i class="pi pi-file-pdf" style="font-size: 1.5rem; color:crimson"></i>
          <div>
            {{ documento.nombre }}
          </div>
          <button pButton icon="pi pi-desktop" [label]="trans.abrir"
            (click)="downloadFormFile(false, documento.id, documento.nombre)"
            [disabled]="!ls.hasRole(role.ADMIN_TRAM)"></button>
          <button pButton icon="pi pi-download" [label]="trans.descargar" class="p-button-success"
            (click)="downloadFormFile(true, documento.id, documento.nombre)"
            [disabled]="!ls.hasRole(role.ADMIN_TRAM)"></button>
        </div>
      }
    </div>
    <ng-template #cargando>
      <div class="flex flex-column gap-2">
        <p-skeleton width="15rem"></p-skeleton>
        <p-skeleton width="15rem"></p-skeleton>
      </div>
    </ng-template>
    <ng-container *ngIf="!ls.hasRole(role.ADMIN_TRAM)">
      <small class="p-error block"> {{ trans.noPermisoDescargar }}</small>
    </ng-container>
  </div>

</section>
